import { css } from '@emotion/react';
import styled from '@emotion/styled';
export const StepLinkWrapper = styled.div<{ disabled?: boolean }>`
    position: relative;
    z-index: 1;
    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
    opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
    transition: opacity 0.3s ease-in-out;
`;

export const StepItemContainer = styled.div<{
    status: 'done' | 'current' | 'upcoming';
    active: boolean;
    disabled?: boolean;
}>`
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #fff;
    border-radius: 5px;
    padding: 6px 8px;
    width: 212px;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border: ${({ status, active, disabled }) => {
        if (disabled) return '1px solid #D3D3D3';
        return status === 'current' || active ? '1px solid #6025D8' : '1px solid #E3E3E3';
    }};
    transition: all 0.3s ease-in-out;
`;

export const StepLabel = styled.span<{
    status: 'done' | 'current' | 'upcoming';
    disabled?: boolean;
}>`
    font-weight: bold;
    font-size: 15px;
    color: ${({ disabled }) => (disabled ? '#A0A0A0' : '#000')};
`;

export const StepIconCircle = styled.div<{
    status: 'done' | 'current' | 'upcoming';
}>`
    background-color: ${({ status }) =>
        status === 'done'
            ? '#00C853'
            : status === 'current'
              ? '#5d3fd3'
              : 'rgba(93, 63, 211, 0.1)'};
    width: 25px;
    height: 25px;
    min-width: 25px;
    max-width: 25px;
    min-height: 25px;
    max-height: 25px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    svg {
        fill: white;
        ${({ status }) =>
            status === 'upcoming' &&
            `
      fill: #4A52BB;
    `}
    }
`;

export const StepperContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 28px;
    margin-right: 32px;
    margin-top: 2px;
`;

export const StepConnector = styled.div<{ status: 'done' | 'current' | 'upcoming' }>`
    position: absolute;
    top: 100%;
    right: 20px; // Adjust based on StepItem padding
    height: 28px;
    width: 4px;

    ${({ status }) =>
        status === 'done' || status === 'current'
            ? css`
                  background-color: #4a52bb;
              `
            : css`
                  border-right: 4px dashed #4a52bb;
                  background-color: transparent;
              `}
`;
